import { FONT_SIZE_MODIFIER_PREFIX } from '../../text-formatting/constants/font-size';
import { TEXT_INTENT_MODIFIER_PREFIX } from '../../text-formatting/constants/text-indent';
import { stripBreakpointPrefix, supportedClasses } from '@yola/atomic-css-generator';

const removeUnsupportedClassNames = (element) => {
  Array.from(element.classList).forEach((className) => {
    const strippedClass = stripBreakpointPrefix(className);

    if (
      [FONT_SIZE_MODIFIER_PREFIX, TEXT_INTENT_MODIFIER_PREFIX].some((prefix) =>
        className.startsWith(prefix)
      )
    )
      return;

    if (
      supportedClasses.some((cls) => strippedClass === cls || strippedClass.startsWith(`${cls}-`))
    )
      return;

    element.classList.remove(className);
  });

  if (element.classList.length === 0) {
    element.removeAttribute('class');
  }
};

export default removeUnsupportedClassNames;
